// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3R1Th","options":"AnswerScale_options__2N3AQ","selected":"AnswerScale_selected__3t8Oe"};